(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/button-list.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/button-list.js');
"use strict";


const ButtonList = _ref => {
  let {
    buttonOptions,
    sum
  } = _ref;
  const PayButton = svs.tur.ReactPayfooter.PayButton;
  const PrimaryButton = svs.tur.ReactPayfooter.PrimaryButton;
  const SecondaryButton = svs.tur.ReactPayfooter.SecondaryButton;
  const LinkButton = svs.tur.ReactPayfooter.LinkButton;
  const SubmitButton = svs.tur.ReactPayfooter.SubmitButton;
  const ButtonWithDescription = svs.tur.ReactPayfooter.ButtonWithDescription;
  return React.createElement(React.Fragment, null, buttonOptions && Array.isArray(buttonOptions) && buttonOptions.filter(_ref2 => {
    let {
      visible = true
    } = _ref2;
    return visible;
  }).map((_ref3, index) => {
    let {
      className,
      onClick,
      text,
      primary,
      secondary,
      transparent = true,
      link,
      pay,
      disabled = false,
      isSubmit,
      formName,
      description
    } = _ref3;
    const key = "payfooterBtn_".concat(index, "_").concat(text);
    let button;
    if (pay) {
      button = React.createElement(PayButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick,
        sum: sum
      });
    } else if (primary) {
      button = React.createElement(PrimaryButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick
      }, text);
    } else if (secondary) {
      button = React.createElement(SecondaryButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick,
        transparent: transparent
      }, text);
    } else if (link) {
      button = React.createElement(LinkButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick
      }, text);
    } else if (isSubmit) {
      button = React.createElement(SubmitButton, {
        className: className,
        disabled: disabled,
        formName: formName,
        isSubmit: isSubmit,
        key: key,
        onClick: onClick
      }, text);
    }
    if (button) {
      if (description) {
        return React.createElement(ButtonWithDescription, {
          button: button,
          description: description,
          key: key
        });
      }
      return button;
    }
    return null;
  }));
};
svs.tur.ReactPayfooter.ButtonList = ButtonList;

 })(window);